import { Box } from '@vp/swan'
export const SpacingWrapper = (props) => {
  return (
    <Box marginTop={2} marginBottom='between-sections'>{props.children}</Box>
  )
}
